import { TableCell, TableRow } from '@ui/components/Table';

import { GameMovementPlayer } from '@features/shared/api/typings';
import styles from '@features/tournament/ui/components/RoundMovement/RoundMovement.module.css';

type TotalMovementRowProps = {
  total: {
    player1: GameMovementPlayer;
    player2: GameMovementPlayer;
  };
};

export function TotalMovementRow({ total }: TotalMovementRowProps) {
  return (
    <TableRow className={styles.total} hoverable>
      <TableCell className={styles.no}>Итого</TableCell>
      <TableCell className={styles.playerName}></TableCell>
      <TableCell className={styles.results}>
        <div className={styles.totalScore}>{total.player1.game.score}</div>
        <div className={styles.totalScore}>{total.player2.game.score}</div>
      </TableCell>
      <TableCell left className={styles.playerName}></TableCell>
    </TableRow>
  );
}
